/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTION_LOCATIONS_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.locations,
                (memo, location) => {
                    const { connection_id } = location;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[connection_id] = location;
                    return memo;
                },
                state,
            );
        }
    },
);